import { render, staticRenderFns } from "./ImageObjectEditForm.vue?vue&type=template&id=778d41bc&scoped=true&"
import script from "./ImageObjectEditForm.vue?vue&type=script&lang=ts&"
export * from "./ImageObjectEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./ImageObjectEditForm.vue?vue&type=style&index=0&id=778d41bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d41bc",
  null
  
)

export default component.exports